export default __webpack_public_path__ + "static/char-v-62-4ee5feffeed10c2bc80da8467c0979ab.png";